export const ON_PROD = process.env.NODE_ENV === 'production' // could also be staging!
export const ON_DEV = process.env.NODE_ENV === 'development'

export const IS_STAGE = process.env.VUE_APP_PROJECT_ID === 'dj-staging'